export default __webpack_public_path__ + "static/media/icon_iost.229a1de3.svg";